import React from "react";
import ReadIcon from "../../img/readIcon.png";

export const EnvelopCircleIcon = (props) => {
  const imgclassName = props?.className ? props?.className : "df-w-42";

  return (
    <>
      <img src={ReadIcon} className={imgclassName} />
    </>
  );
};
